module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-navigation-drawer', {
    staticClass: "pb-0",
    staticStyle: {
      "background-color": "#607d8b!important"
    },
    attrs: {
      "fixed": "",
      "left": "",
      "permanent": "",
      "clipped": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('div', [(_vm.dashnosections.length > 0) ? _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.dashnosections), function(item) {
    return _c('v-list-tile', {
      key: item.blockId,
      class: {
        'isActive': _vm.selectedSection.blockId == item.blockId
      },
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.switcher(item)
        }
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          _vm.$set(item, "active", $$v)
        },
        expression: "item.active"
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.blockName) + " (" + _vm._s(item.recordCount) + ")")])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.dashnosections.length == 0) ? _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("No hearings assigned")])], 1)], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [(_vm.$store.state.isHearingSupervisor == true) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": "",
      "lg3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.$store.state.refData.hearingReps,
      "chips": "",
      "deletable-chips": "",
      "label": "Hearing Reps",
      "item-text": "description",
      "item-value": "id"
    },
    on: {
      "change": _vm.hearingRepChanged
    },
    model: {
      value: (_vm.selectedHearingRep),
      callback: function($$v) {
        _vm.selectedHearingRep = $$v
      },
      expression: "selectedHearingRep"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.selectedSection.blockId) ? _c('grid', {
    attrs: {
      "gridTitle": _vm.selectedSection.blockName
    },
    model: {
      value: (_vm.selectedGrid),
      callback: function($$v) {
        _vm.selectedGrid = $$v
      },
      expression: "selectedGrid"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fa19ab94", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa19ab94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/portalhome/docketing/pages/dashboard/dashboard.vue.html
// module id = 596
// module chunks = 0